import { c as _c } from "react/compiler-runtime";
import Image from 'next/image';
import type { Network } from '@/modules/__generated__/graphql/switchboard-generated';
import { selectNetworkImages } from '@/modules/shared/lib/network-brand-utils';
import { NetworkImage } from './network-image';

/**
 * Network logo for desktop view
 */
function NetworkLogo(t0) {
  const $ = _c(18);
  const {
    network
  } = t0;
  let t1;
  if ($[0] !== network) {
    t1 = selectNetworkImages(network, "logo");
    $[0] = network;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const imageSelection = t1;
  if (imageSelection.source === "none") {
    const t2 = network.name ?? "";
    let t3;
    if ($[2] !== t2) {
      t3 = <Image src="/networks/logos/unknown.png" alt={t2} width={32} height={32} priority={true} fetchPriority="high" />;
      $[2] = t2;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    const t4 = network.name ?? "";
    let t5;
    if ($[4] !== t4) {
      t5 = <span className="font-bold">{t4}</span>;
      $[4] = t4;
      $[5] = t5;
    } else {
      t5 = $[5];
    }
    let t6;
    if ($[6] !== t3 || $[7] !== t5) {
      t6 = <div className="hidden items-center justify-center gap-2 lg:flex">{t3}{t5}</div>;
      $[6] = t3;
      $[7] = t5;
      $[8] = t6;
    } else {
      t6 = $[8];
    }
    return t6;
  }
  if (imageSelection.source === "icon") {
    const t2 = network.name ?? "";
    const t3 = network.name ?? "";
    let t4;
    if ($[9] !== imageSelection.darkImage || $[10] !== imageSelection.lightImage || $[11] !== t2 || $[12] !== t3) {
      t4 = <NetworkImage lightImage={imageSelection.lightImage} darkImage={imageSelection.darkImage} alt={t2} size={32} lightClassName="block dark:hidden" darkClassName="hidden dark:block" singleClassName="" useImgTag={false} showName={true} networkName={t3} containerClassName="hidden items-center justify-center gap-2 lg:flex" />;
      $[9] = imageSelection.darkImage;
      $[10] = imageSelection.lightImage;
      $[11] = t2;
      $[12] = t3;
      $[13] = t4;
    } else {
      t4 = $[13];
    }
    return t4;
  }
  const t2 = network.name ?? "";
  let t3;
  if ($[14] !== imageSelection.darkImage || $[15] !== imageSelection.lightImage || $[16] !== t2) {
    t3 = <NetworkImage lightImage={imageSelection.lightImage} darkImage={imageSelection.darkImage} alt={t2} size={32} lightClassName="hidden h-8 w-auto lg:block dark:lg:hidden" darkClassName="hidden h-8 w-auto lg:hidden dark:lg:block" singleClassName="hidden h-8 w-auto lg:flex" useImgTag={true} showName={false} />;
    $[14] = imageSelection.darkImage;
    $[15] = imageSelection.lightImage;
    $[16] = t2;
    $[17] = t3;
  } else {
    t3 = $[17];
  }
  return t3;
}
export { NetworkLogo };